import { api } from '../services/api'
import { normalizeCpf } from './normalizeCpf'

export const isCpfAvailable = async (cpf: string, currentUserCpf?: string) => {
  try {
    const normalizedCpf = normalizeCpf(cpf)
    const response = await api.get(`/experts/cpf-available/${normalizedCpf}`)
    const isAvailable = response.data

    if (currentUserCpf) {
      const normalizedCurrentUserCpf = normalizeCpf(currentUserCpf)
      return isAvailable || normalizedCpf === normalizedCurrentUserCpf
    }

    return isAvailable
  } catch {
    return true
  }
}
